import { DataBean } from "../DataBean";

export class QualityErrorDetails extends DataBean {

  public async getQualityErrorDetailsCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityErrorDetailsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteQualityErrorDetails(idqualityerrordetails: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityErrorDetails_Number", [idqualityerrordetails]);
  }

  public async updateQualityErrorDetails(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityErrorDetails_updateQualityErrorDetails_com.orange.finance.processcontract.bean.QualityErrorDetails",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityErrorDetails",
        },
      ]
    );
  }
}
